import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class Unspecified extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render() {
        return (
            <span className={'unspecified'} title={ this.props.t(`visualizer:toolbar.left.collaborativeIndexationCreation.fields.values.unspecified`) }>
                { this.props.t(`visualizer:toolbar.left.collaborativeIndexationCreation.fields.values.unspecified`) }
            </span>
        )
    }
}

export default withTranslation()(Unspecified)
